// @ts-ignore
import testAssets from "../../main/src/bundle.scoped.esm.js";

import "./bundle.esm.js";

export default testAssets;
